// Ensure singleton is used to avoid errors since some browsers have limitations
var audioContextSingleton = null;

export var getAudioContext = function getAudioContext() {
  if (!audioContextSingleton) {
    try {
      audioContextSingleton = new window.AudioContext();
    } catch (e) {
      audioContextSingleton = new window.webkitAudioContext();
    }
  }
  return audioContextSingleton;
};